module.exports = __webpack_public_path__ + "static/media/search-minus.ff7fae74.svg";